import React, { useState } from "react";
import { connect } from "react-redux";
import {
  getBackgroundColor,
  getEnabledSectionsMenu
} from "Portal/NewPortal/PortalHome/selectors";
import BottomFlyOver from "Portal/NewPortal/Shared/BottomFlyOver";
import Body from "./Body";

const decorate = connect(state => ({
  backgroundColor: getBackgroundColor(state),
  categories: getEnabledSectionsMenu(state)
}));

const MobileFooter = ({ backgroundColor, categories }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOpen = () => setIsOpen(true);

  const handleClose = () => setIsOpen(false);

  return (
    <div
      style={{
        backgroundColor,
        position: "fixed",
        bottom: 0,
        width: "100%",
        height: "76px",
        padding: "20px",
        borderTop: "1px #E7E6EA solid"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          width: "100%",
          fontSize: "14px",
          fontWeight: "600",
          paddingLeft: "16px",
          paddingRight: "16px",
          borderRadius: "6px",
          border: "1px #E7E6EA solid",
          cursor: "pointer",
          height: "100%"
        }}
        onClick={handleClickOpen}
      >
        <i
          className={`material-icons-outlined dashboard`}
          style={{
            fontSize: "14px",
            fontWeight: "600"
          }}
        >
          dashboard
        </i>
        {categories.length > 1 ? `Pages (${categories.length - 1})` : "Page"}
      </div>
      <BottomFlyOver open={isOpen} handleClose={handleClose}>
        <Body handleClose={handleClose} />
      </BottomFlyOver>
    </div>
  );
};

export default decorate(MobileFooter);
